import React from "react";
import {Card, Form, Input} from "antd";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import PerfInput from "../../../../../components/perf-input";
import ZoomableTextArea from "../../../../../components/zoomable-textarea";

const mapStateToProps = state => ({
    dsPrefix: state.config.dataManagement.datasetPrefix
});

const SecondStep = ({t, form, disableModify, isDataflowBuilder, dsPrefix}) => {
    return (
        <Card>
        <Form style={{display: "flex", justifyContent: "center", height: "100%", flexDirection: "column"}}>
            <Form.Item
                label={t('scenes.mappingHandler.DatasetBuilder.wizard.step.second.datasetName')}
                className="ant-form-item-required"
                required
                validateStatus={((form.getFieldValue("name") || "").substring(0, dsPrefix.length).toLowerCase().includes(dsPrefix.toLowerCase()) && !isDataflowBuilder) ? "warning" : null}
                help={((form.getFieldValue("name") || "").substring(0, dsPrefix.length).toLowerCase().includes(dsPrefix.toLowerCase()) && !isDataflowBuilder) ? t("scenes.mappingHandler.DatasetBuilder.wizard.step.second.datasetNameDSError", {dsPrefix}) : null}
            >
                {form.getFieldDecorator('name')(
                    <PerfInput
                        Component={Input}
                        title={form.getFieldValue('name')}
                        disabled={disableModify}
                    />
                )}
            </Form.Item>
            <Form.Item
                label={t('scenes.mappingHandler.DatasetBuilder.wizard.step.second.datasetDescription')}>
                {form.getFieldDecorator('description')(
                    <ZoomableTextArea disabled={disableModify} title={form.getFieldValue('description')}/>
                )}
            </Form.Item>
        </Form>
        </Card>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps),
)(SecondStep)
